import React, { useState } from "react"
import FileUploader from "../FileUploader"
import { Button } from "antd"
import { DeleteOutlined } from "@ant-design/icons"
import RemoteFile from "../RemoteFile"

const FormFileUploader = ({
  value,
  onChange,
  isPublic = true,
  accept,
  onRemove,
}) => {
  const [fileId, setFileId] = useState(value)

  const onUploadCompleted = ({ file_id }) => {
    onChange(file_id)
    setFileId(file_id)
  }

  const removeFile = () => {
    setFileId(null)
    onChange(null)
    onRemove && onRemove()
  }

  return (
    <div className={"file-uploader"}>
      <FileUploader
        onSuccess={onUploadCompleted}
        isPublic={isPublic}
        accept={accept}
      />
      {fileId && (
        <div style={{ maxWidth: 350, position: "relative" }}>
          <RemoteFile fileId={fileId} />
          <Button
            className="btn-remove"
            danger
            type="primary"
            shape="circle"
            onClick={removeFile}
            icon={<DeleteOutlined />}
            style={{
              position: "absolute",
              top: 40,
              right: 10,
            }}
          />
        </div>
      )}
    </div>
  )
}

export default FormFileUploader
